export default __webpack_public_path__ + "static/media/delete_dark_accent.f2b55384.svg";